import InternalAvatar from './avatar';
import Group from './group';
var Avatar = InternalAvatar;
Avatar.Group = Group;
export { Group };
export default Avatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/avatar/index.js
// module id = 244
// module chunks = 0